import styled from "@emotion/styled";

const FormFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
`;

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default FormFooter;
